import React, { useState } from "react";
import AuthHeader from "../components/AuthHeader";

const isDev = process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:8000" : "/api";

// 登録カテゴリ。重要例文=10文、パッセージ=3文（バックエンドで検証）。
// 単語(j2_words)は「N章」CSV形式。既登録の章があれば全件中止。
const CATEGORY_OPTIONS = [
  { value: "j2_sentences", label: "j2_sentences（中2 重要例文・10文）" },
  { value: "j2_passages", label: "j2_passages（中2 パッセージ・3文）" },
  { value: "j2_words", label: "j2_words（中2 単語）" },
];

const PLACEHOLDER_SENTENCES = `Track 3-13
1
If you say that, you will be laughed at by everyone.
もしそれを言ったら皆から笑われますよ。
2
His songs can be listened to for free on the Internet.
彼の曲はインターネットで無料で聞くことができる。
...（各Trackは10文ちょうど）`;

const PLACEHOLDER_WORDS = `9章
□,文,1,light bulb,句,電球,change a light bulb,電球を変える
★,,2,invent,動,発明する,invent a new machine,新しい機械を発明する
★,,3,fix,動,"修理する，修復する",fix a computer,コンピューターを修理する
10章
★,,1,laugh,動,笑う,laugh at someone,（人）を笑う
...（列: 宿題□★, 出題箇所, 章内番号, 英単語, 品詞, 意味, 例文, 例文和訳）`;

const J2TextRegisterPage = () => {
  const [category, setCategory] = useState("j2_sentences");
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!text.trim()) {
      alert("テキストを入力してください");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/save_j2_text`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category, text }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || `HTTP ${res.status}: ${res.statusText}`);
      }
      alert(data.message || "登録しました");
      setText("");
    } catch (err) {
      console.error("J2登録エラー:", err);
      alert(`登録できませんでした: ${err.message || err.toString()}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <AuthHeader />
      <div style={{ maxWidth: 820, margin: "20px auto", padding: "0 16px" }}>
        <h2>中2 教材登録（テキスト入力）</h2>
        {category === "j2_words" ? (
          <p style={{ color: "#666", fontSize: 14 }}>
            単語のCSVを貼り付けてDB登録します。「N章」行で章を区切り、以降の行が
            カンマ区切りCSV（宿題□★, 出題箇所, 章内番号, 英単語, 品詞, 意味, 例文, 例文和訳）。
            複数章に対応。既登録の章があれば何も登録されません。
          </p>
        ) : (
          <p style={{ color: "#666", fontSize: 14 }}>
            生成AIで文字起こししたテキストを貼り付けてDB登録します。複数の「Track X-Y」ブロックに対応。
            各Trackは規定数ちょうど（重要例文=10文／パッセージ=3文）・既登録のtrack_idは登録不可
            （いずれも満たさない場合は何も登録されません）。
          </p>
        )}

        <div style={{ marginBottom: 12 }}>
          <label style={{ marginRight: 8 }}>カテゴリー：</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            {CATEGORY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={24}
          placeholder={category === "j2_words" ? PLACEHOLDER_WORDS : PLACEHOLDER_SENTENCES}
          style={{ width: "100%", fontFamily: "monospace", fontSize: 14, boxSizing: "border-box" }}
        />

        <div style={{ marginTop: 12 }}>
          <button onClick={handleSubmit} disabled={saving}>
            {saving ? "登録中..." : "DB登録"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default J2TextRegisterPage;
